module.exports = __webpack_public_path__ + "img/log_keyboard.f6695d34.png";